module.exports = __webpack_public_path__ + "static/media/cloud-hail-mixed.791d6dc1.svg";